import classNames from 'classnames';
import './styles.less';
import { statusTagColors } from './StatusTagColors';
import { getContrastColor } from '@/utils/functions/getContrastColor';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Group from '../Group';

type Option = { label: string; value: string };

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  label: React.ReactNode;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  disabledOption?: boolean;
  options?: Option[];
  value?: string;
  onStatusChange?: (value: string) => void;
};

const StatusTag: React.FC<Props> = ({
  label,
  color = 'default',
  size = 'md',
  disabled = false,
  disabledOption = true,
  options,
  value,
  onStatusChange,
  ...props
}) => {
  const colorStyle = statusTagColors[color] || {
    background: color,
    color: color.includes('#') ? getContrastColor(color) : 'white',
  };

  return (
    <div
      {...props}
      className={classNames(
        'status-tag',
        {
          'size-sm': size === 'sm',
          'size-md': size === 'md',
          'size-lg': size === 'lg',
        },
        props.className,
      )}
      style={{
        cursor: disabled ? 'not-allowed' : options ? 'default' : undefined,
        opacity: disabled ? 0.5 : undefined,
        ...colorStyle,
        ...props.style,
        paddingRight: options ? 4 : undefined,
      }}
      onClick={!disabled && !options ? props?.onClick : undefined}
    >
      {options && !disabled && !disabledOption ? (
        <Dropdown
          className="user-dropdown"
          overlay={
            <Menu
              selectedKeys={[value ?? '']}
              onClick={(menu) => onStatusChange?.(menu.key)}
              items={options.map((option) => ({
                label: option.label,
                key: option.value,
              }))}
            />
          }
          trigger={['click']}
        >
          <Group gap={5}>
            {label}

            <DownOutlined />
          </Group>
        </Dropdown>
      ) : (
        label
      )}
    </div>
  );
};

export default StatusTag;
